// for ag-grid localization for Chinese (Traditional) -- zh-Hant
// we will use this for zh-Hant, zh-Hant-TW, zh-Hant-HK, zh-Hant-MO, zh-TW, zh-HK, zh-MO

export default {
    // Set Filter
    selectAll: '（全選）',
    selectAllSearchResults: '（全選搜尋結果）',
    searchOoo: '搜尋...',
    blanks: '（空白）',
    noMatches: '沒有相符項目',

    // Number Filter & Text Filter
    filterOoo: '篩選...',
    equals: '等於',
    notEqual: '不等於',
    empty: '請選擇',

    // Number Filter
    lessThan: '小於',
    greaterThan: '大於',
    lessThanOrEqual: '小於或等於',
    greaterThanOrEqual: '大於或等於',
    inRange: '介於',
    inRangeStart: '到',
    inRangeEnd: '從',

    // Text Filter
    contains: '包含',
    notContains: '不包含',
    startsWith: '開頭為',
    endsWith: '結尾為',

    // Date Filter
    dateFormatOoo: 'yyyy-mm-dd',

    // Filter Conditions
    andCondition: '與',
    orCondition: '或',

    // Filter Buttons
    applyFilter: '套用',
    resetFilter: '重設',
    clearFilter: '清除',
    cancelFilter: '取消',

    // Filter Titles
    textFilter: '文字篩選器',
    numberFilter: '數字篩選器',
    dateFilter: '日期篩選器',
    setFilter: '集合篩選器',

    // Side Bar
    columns: '欄',
    filters: '篩選器',

    // columns tool panel
    pivotMode: '樞紐分析模式',
    groups: '資料列群組',
    rowGroupColumnsEmptyMessage: '將欄拖曳到這裡以設定資料列群組',
    values: '值',
    valueColumnsEmptyMessage: '將欄拖曳到這裡以進行彙總',
    pivots: '欄標籤',
    pivotColumnsEmptyMessage: '將欄拖曳到這裡以設定欄標籤',

    // Header of the Default Group Column
    group: '群組',

    // Other
    loadingOoo: '載入中...',
    noRowsToShow: '沒有可顯示的資料列',
    enabled: '已啟用',

    // Menu
    pinColumn: '固定欄',
    pinLeft: '固定在左側',
    pinRight: '固定在右側',
    noPin: '不固定',
    valueAggregation: '值彙總',
    autosizeThiscolumn: '自動調整此欄寬度',
    autosizeAllColumns: '自動調整所有欄寬度',
    groupBy: '群組依據',
    ungroupBy: '取消群組依據',
    resetColumns: '重設欄',
    expandAll: '全部展開',
    collapseAll: '全部收合',
    copy: '複製',
    ctrlC: 'Ctrl+C',
    copyWithHeaders: '複製（含標題）',
    paste: '貼上',
    ctrlV: 'Ctrl+V',
    export: '匯出',
    csvExport: '匯出為 CSV',
    excelExport: '匯出為 Excel',

    // Enterprise Menu Aggregation and Status Bar
    sum: '加總',
    min: '最小值',
    max: '最大值',
    none: '無',
    count: '計數',
    avg: '平均值',
    filteredRows: '已篩選',
    selectedRows: '已選取',
    totalRows: '總列數',
    totalAndFilteredRows: '列數',
    more: '更多',
    to: '至',
    of: '共',
    page: '頁',
    nextPage: '下一頁',
    lastPage: '最後一頁',
    firstPage: '第一頁',
    previousPage: '上一頁',

    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: '樞紐分析圖與樞紐分析模式',
    pivotChart: '樞紐分析圖',
    chartRange: '圖表範圍',

    columnChart: '直條圖',
    groupedColumn: '群組',
    stackedColumn: '堆疊',
    normalizedColumn: '100% 堆疊',

    barChart: '橫條圖',
    groupedBar: '群組',
    stackedBar: '堆疊',
    normalizedBar: '100% 堆疊',

    pieChart: '圓形圖',
    pie: '圓形圖',
    doughnut: '環圈圖',

    line: '折線圖',

    xyChart: 'XY（散佈圖）',
    scatter: '散佈圖',
    bubble: '泡泡圖',

    areaChart: '區域圖',
    area: '區域圖',
    stackedArea: '堆疊',
    normalizedArea: '100% 堆疊',

    histogramChart: '直方圖',

    // Charts
    pivotChartTitle: '樞紐分析圖',
    rangeChartTitle: '範圍圖表',
    settings: '設定',
    data: '資料',
    format: '格式',
    categories: '類別',
    defaultCategory: '（無）',
    series: '數列',
    xyValues: 'XY 值',
    paired: '配對模式',
    axis: '座標軸',
    navigator: '導覽器',
    color: '色彩',
    thickness: '粗細',
    xType: 'X 類型',
    automatic: '自動',
    category: '類別',
    number: '數字',
    time: '時間',
    xRotation: 'X 軸旋轉',
    yRotation: 'Y 軸旋轉',
    ticks: '刻度',
    width: '寬度',
    height: '高度',
    length: '長度',
    padding: '內距',
    spacing: '間距',
    chart: '圖表',
    title: '標題',
    titlePlaceholder: '圖表標題 - 按兩下以編輯',
    background: '背景',
    font: '字型',
    top: '上',
    right: '右',
    bottom: '下',
    left: '左',
    labels: '標籤',
    size: '大小',
    minSize: '最小大小',
    maxSize: '最大大小',
    legend: '圖例',
    position: '位置',
    markerSize: '標記大小',
    markerStroke: '標記筆畫',
    markerPadding: '標記內距',
    itemSpacing: '項目間距',
    itemPaddingX: '項目內距 X',
    itemPaddingY: '項目內距 Y',
    layoutHorizontalSpacing: '水平間距',
    layoutVerticalSpacing: '垂直間距',
    strokeWidth: '筆畫寬度',
    offset: '位移',
    offsets: '位移',
    tooltips: '工具提示',
    callout: '標註',
    markers: '標記',
    shadow: '陰影',
    blur: '模糊',
    xOffset: 'X 位移',
    yOffset: 'Y 位移',
    lineWidth: '線條寬度',
    normal: '正常',
    bold: '粗體',
    italic: '斜體',
    boldItalic: '粗斜體',
    predefined: '預先定義',
    fillOpacity: '填滿不透明度',
    strokeOpacity: '線條不透明度',
    histogramBinCount: '區間數量',
    columnGroup: '直條圖',
    barGroup: '橫條圖',
    pieGroup: '圓形圖',
    lineGroup: '折線圖',
    scatterGroup: 'XY（散佈圖）',
    areaGroup: '區域圖',
    histogramGroup: '直方圖',
    groupedColumnTooltip: '群組',
    stackedColumnTooltip: '堆疊',
    normalizedColumnTooltip: '100% 堆疊',
    groupedBarTooltip: '群組',
    stackedBarTooltip: '堆疊',
    normalizedBarTooltip: '100% 堆疊',
    pieTooltip: '圓形圖',
    doughnutTooltip: '環圈圖',
    lineTooltip: '折線圖',
    groupedAreaTooltip: '區域圖',
    stackedAreaTooltip: '堆疊',
    normalizedAreaTooltip: '100% 堆疊',
    scatterTooltip: '散佈圖',
    bubbleTooltip: '泡泡圖',
    histogramTooltip: '直方圖',
    noDataToChart: '沒有可用於繪製圖表的資料。',
    pivotChartRequiresPivotMode: '樞紐分析圖需要啟用樞紐分析模式。',
    chartSettingsToolbarTooltip: '選單',
    chartLinkToolbarTooltip: '已連結至表格',
    chartUnlinkToolbarTooltip: '已從表格取消連結',
    chartDownloadToolbarTooltip: '下載圖表',

    // ARIA
    ariaHidden: '隱藏',
    ariaVisible: '可見',
    ariaChecked: '已勾選',
    ariaUnchecked: '未勾選',
    ariaIndeterminate:'不確定',
    ariaColumnSelectAll: '切換全選所有欄',
    ariaInputEditor: '輸入編輯器',
    ariaDateFilterInput: '日期篩選器輸入方塊',
    ariaFilterInput: '篩選器輸入方塊',
    ariaFilterColumnsInput: '欄篩選器輸入方塊',
    ariaFilterValue: '篩選值',
    ariaFilterFromValue: '從此值開始篩選',
    ariaFilterToValue: '篩選至此值',
    ariaFilteringOperator: '篩選運算子',
    ariaColumnToggleVisibility: '切換欄可見性',
    ariaColumnGroupToggleVisibility: '切換欄群組可見性',
    ariaRowSelect: '按空白鍵以選取此列',
    ariaRowDeselect: '按空白鍵以取消選取此列',
    ariaRowToggleSelection: '按空白鍵以切換列選取',
    ariaRowSelectAll: '按空白鍵以切換所有列的選取',
    ariaSearch: '搜尋',
    ariaSearchFilterValues: '搜尋篩選值'
}